import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const catalogAdminMapleJobDashboardAccessConfiguration: DomainAccessControlConfig = {
  permissions: Permission.CatalogAdminViewAccess,
}
